fragment ProductAttributeValueFragment on ProductAttributeValue {
    id
    product_id
    attribute_id
    option_id
    media_id
    color_id
    value_string
    value_int
    value_decimal
    value_text
    payload

    attribute {
        ...ProductAttributeFragment
    }

    option {
        ...ProductAttributeOptionFragment
    }

    color {
        id
        code
        name
        brand
        hex_codes
        color_group_id
    }
}